import useAuth from '@/composables/useAuth';

export type ChilipiperObject = {
  domElement?: string;
  chilipiperRouter: string;
  campaign: string;
  onSuccess?: () => void;
  onClose?: () => void;
  onError?: () => void;
};

export function useChilipiper() {
  const { currentOrg, currentUser } = useAuth();

  const displayChilipiperWidget = ({
    domElement,
    chilipiperRouter,
    campaign,
    onSuccess,
    onClose,
    onError = onClose,
  }: ChilipiperObject) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chiliPiper = (window as any).ChiliPiper;
    // Concierge script in index.html can fail to load (ad blockers, third-party
    // script policies, network failures) — bail via onError so callers aren't
    // left staring at an empty embed.
    if (!chiliPiper?.submit) {
      onError?.();
      return;
    }
    try {
      chiliPiper.submit('crossbeam', chilipiperRouter, {
        lead: {
          Campaign_content__c: campaign,
          Company: currentOrg.value.name,
          Email: currentUser.value.email,
          FirstName: currentUser.value.first_name,
          LastName: currentUser.value.last_name,
          LeadSource: 'Chili Piper',
          Time_Zone__c: new Date().getTimezoneOffset(),
        },
        map: true,
        domElement: domElement ? `#${domElement}` : undefined,
        onSuccess,
        onClose,
        onError,
      });
    } catch {
      onError?.();
    }
  };

  return { displayChilipiperWidget };
}
